// eslint-disable-next-line import/prefer-default-export
export const HAVE_ALERTS_REFETCH_INTERVAL = 600000
